import React, { useState } from "react";
import axios from "axios";

const RegisterScreen = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [userType, setUserType] = useState("");

  const handleRegister = async (e) => {
    e.preventDefault();
    if (!username || !password || !repeatPassword || !userType) {
      alert("Please fill out all fields");
      return;
    }
    if (password !== repeatPassword) {
      alert("Passwords do not match");
      return;
    }

    try {
      const response = await axios.post("https://kartikenterprisesindia.co.in/api/users", {
        username,
        password,
        role: userType,
      });

      if (response.status === 201) {
        alert("User registered successfully");
      }
    } catch (error) {
      alert(error.response?.data?.error || "Failed to register user");
      console.error(error);
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.header}>Register</h2>
      <form style={styles.form} onSubmit={handleRegister}>
        <label style={styles.label}>Username</label>
        <input
          type="text"
          style={styles.input}
          placeholder="Enter Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />

        <label style={styles.label}>Password</label>
        <input
          type="password"
          style={styles.input}
          placeholder="Enter Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <label style={styles.label}>Repeat Password</label>
        <input
          type="password"
          style={styles.input}
          placeholder="Repeat Password"
          value={repeatPassword}
          onChange={(e) => setRepeatPassword(e.target.value)}
        />

        <label style={styles.label}>User Type</label>
        <select
          style={styles.select}
          value={userType}
          onChange={(e) => setUserType(e.target.value)}
        >
          <option value="" disabled>
            Select user type
          </option>
          <option value="ADMIN">Admin</option>
          <option value="BRANCH">Branch</option>
        </select>

        <button type="submit" style={styles.button}>
          Register
        </button>
      </form>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "400px",
    margin: "50px auto",
    padding: "20px",
    border: "1px solid #ddd",
    borderRadius: "5px",
    backgroundColor: "#f9f9f9",
  },
  header: {
    textAlign: "center",
    marginBottom: "20px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    marginBottom: "5px",
    fontSize: "14px",
    color: "#333",
  },
  input: {
    height: "35px",
    padding: "5px 10px",
    marginBottom: "15px",
    borderRadius: "4px",
    border: "1px solid #ddd",
  },
  select: {
    height: "35px",
    marginBottom: "15px",
    borderRadius: "4px",
    border: "1px solid #ddd",
    padding: "5px 10px",
  },
  button: {
    padding: "10px",
    fontSize: "16px",
    color: "#fff",
    backgroundColor: "#007BFF",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
};

export default RegisterScreen;
